<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>
<div *ngIf="detailMode; then showSpan else showInput"></div>
<ng-template #showInput>
    <textarea #field class="form-control" [id]="(id === null ? name : id)" [name]="name" [value]="value"
        [rows]="this.rows" [disabled]="readOnly" (input)="changeValue($event)">
    </textarea>
</ng-template>
<ng-template #showSpan>
    <span type="text" #field [id]="(id === null ? name : id)" style="white-space: pre-wrap;">
      {{value}}
    </span>
    <hr *ngIf="includeLabel" />
</ng-template>

<div *ngIf="!detailMode">
    <app-input-feedback [hidden]="!validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
</div>
